module.exports = __webpack_public_path__ + "images/premium-492da7dac007a4ba7635caf3a34eb2d4.jpg";